var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcGoogle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21.988 11.206c0-.901-.075-1.56-.237-2.241H11.22v4.068H17.4c-.125 1.01-.798 2.533-2.293 3.556l-.021.137 3.33 2.52.23.023c2.12-1.912 3.341-4.726 3.341-8.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M11.219 21.924c3.029 0 5.571-.974 7.429-2.655l-3.54-2.68c-.948.646-2.22 1.097-3.89 1.097a6.74 6.74 0 0 1-6.381-4.556l-.132.011-3.462 2.619-.046.123c1.845 3.581 5.634 6.041 10.022 6.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M4.838 13.13a6.61 6.61 0 0 1-.374-2.168c0-.755.137-1.486.362-2.168l-.007-.145-3.506-2.66-.114.052a10.77 10.77 0 0 0-1.197 4.921c0 1.766.436 3.435 1.197 4.921l3.64-2.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M11.219 4.239c2.106 0 3.527.889 4.337 1.632l3.166-3.02C16.778 1.083 14.247 0 11.22 0 6.83 0 3.042 2.46 1.197 6.041l3.627 2.753A6.767 6.767 0 0 1 11.22 4.24z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_google.f76ed848.svg";
export { ForwardRef as ReactComponent };